import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 4),
    transition: "all .3s ease",
    margin: theme.spacing(4, 0),
    boxShadow: `0px 8px 6px -6px rgba(0,0,0,0.1)`,
    borderRadius: 10,
  },
  avatar: {
    width: 60,
    height: 60,
    marginBottom: theme.spacing(2),
  },
  comment: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 6,
    WebkitBoxOrient: "vertical",
    minHeight: 146,
  },
}));

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  userName,
  userJobTitle,
  comments,
  imageUrl,
}) => {
  const classes = useStyles();

  return (
    <Paper
      variant="outlined"
      classes={{ root: classes.root }}
      className="testmonial-message"
    >
      <Box pb={2}>
        <Avatar
          className={classes.avatar}
          src={
            imageUrl.startsWith("/images/")
              ? imageUrl
              : process.env.NEXT_PUBLIC_ADMIN_URL + "storage/images/" + imageUrl
          }
          alt={userName}
        />
        <Typography variant="h4" gutterBottom>
          {userName}
        </Typography>
        <Typography variant="h6" paragraph color="textSecondary">
          {userJobTitle}
        </Typography>
      </Box>
      <Typography className={classes.comment}>{comments}</Typography>
    </Paper>
  );
};

export default TestimonialCard;
